import Events from '@activebrands/core-web/libs/Events';
import { ErrorEvents, FormFlow } from '@activebrands/core-web/libs/Events/types';

/**
 * Fire a form_error tracking event for a confirmed API-side form failure. Client-validation
 * errors are already fired by useForm; these are the server-response failures it can't see.
 * The flow goes out as `form_id`; FormError aggregates into a single `flow:status` token in the
 * `errors` string (error_source='server', error_count=1), matching the client shape.
 *
 * The synthesized InputError carries the status as `error` (→ the token's error_type); `name`/`value`
 * are unused placeholders that satisfy the shared InputError shape.
 */
const trackFormError = (flow: FormFlow, status: number | string) => {
    try {
        Events.trigger(ErrorEvents.FORM, {
            source: 'server',
            flow,
            errors: { [flow]: [{ error: String(status), name: flow, value: '' }] },
        });
    } catch {
        // Analytics must never break the calling flow — these run inside auth/checkout catch blocks.
    }
};

export default trackFormError;
